import { z } from 'zod';
import { managedSecretsProviderEnum } from './managed-secrets.js';

export const authTypeSchema = z.enum(['api-key', 'oauth2', 'none']);
export type AuthType = z.infer<typeof authTypeSchema>;

export const authApiKeyDataSchema = z.object({
  secretIdentifier: z.string(),
  header: z.string(),
});
export const authOauth2DataSchema = z.object({
  connectedAppIdentifier: z.string(),
});

export const authApiKeySchema = z.object({
  type: z.literal('api-key'),
  data: authApiKeyDataSchema,
});
export type AuthApiKey = z.infer<typeof authApiKeySchema>;

export const authOauth2Schema = z.object({
  type: z.literal('oauth2'),
  data: authOauth2DataSchema,
});
export type AuthOauth2 = z.infer<typeof authOauth2Schema>;

export const authNoneSchema = z.object({
  type: z.literal('none'),
  data: z.object({}),
});

export const authSchema = z.union([authApiKeySchema, authOauth2Schema, authNoneSchema]);

export type AuthSchema = z.infer<typeof authSchema>;

///

export const authApiKeyDataDetailsSchema = z.object({
  secret: z.object({
    id: z.number(),
    identifier: z.string(),
    name: z.string(),
    provider: managedSecretsProviderEnum,
    providerKey: z.string(),
  }),
  header: z.string(),
});
export const authOauth2DataDetailsSchema = z.object({
  connectedApp: z.object({
    id: z.number(),
    identifier: z.string(),
    name: z.string(),
  }),
});

export const authApiKeyDetailsSchema = z.object({
  type: z.literal('api-key'),
  data: authApiKeyDataDetailsSchema,
});
export type AuthApiKeyDetails = z.infer<typeof authApiKeyDetailsSchema>;

export const authNoneDetailsSchema = z.object({
  type: z.literal('none'),
  data: z.object({}),
});

export type AuthNoneDetails = z.infer<typeof authNoneDetailsSchema>;

export const authOauth2DetailsSchema = z.object({
  type: z.literal('oauth2'),
  data: authOauth2DataDetailsSchema,
});
export type AuthOauth2Details = z.infer<typeof authOauth2DetailsSchema>;

export const authDetailsSchema = z.union([authApiKeyDetailsSchema, authOauth2DetailsSchema, authNoneDetailsSchema]);

export type AuthDetailsSchema = z.infer<typeof authDetailsSchema>;